"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeEndless = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const CTGGameModeNormal_1 = require("./CTGGameModeNormal");
class CTGGameModeEndless extends CTGGameModeNormal_1.CTGGameModeNormal {
    constructor(generator, starting_rows, speed, animators = null) {
        super(true, generator, starting_rows, speed, animators, 1000000);
        this.win_on_time_out = true;
        this.show_close = true;
    }
    get_time_limit(difficulty) {
        return 60 * 60 * 24 * 1000;
    }
    update_score(score, limit) {
        score = Math.max(0, score);
        this.set_score(score, score / limit);
    }
    card_tapped(card) {
        if (card.tap_requirement == CTGCard_1.CTGTapRequirement.Dont) {
            card.destroy(true);
            this.update_score(this.score - 2, this.score_to_win);
        }
        else {
            card.destroy(true);
            this.update_score(this.score + 1, this.score_to_win);
            if (this.score == this.score_to_win) {
                this.win();
            }
        }
    }
    row_off_screen(row) {
        for (let card of row) {
            if (card.destroyed)
                continue;
            if (card.tap_requirement == CTGCard_1.CTGTapRequirement.Must) {
                this.update_score(this.score - 2, this.score_to_win);
            }
            card.destroy(false);
        }
        ;
    }
}
exports.CTGGameModeEndless = CTGGameModeEndless;
